module.exports = __webpack_public_path__ + "assets/collapse-dark.3ae9b022.svg";